import Header from './Header';
import { Outlet } from 'react-router';
import Footer from './Footer';
import { Alert, Box, Container, IconButton } from '@mui/joy';
import CloseIcon from '@mui/icons-material/Close';
import React from 'react';
import { useAuth } from '../auth/AuthContext';

function Layout({ children }: { children?: React.ReactNode }) {
    const { authError, clearAuthError, claimMessage, clearClaimMessage } = useAuth();

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                minHeight: '100vh',
            }}
        >
            <Header />

            {authError && (
                <Alert
                    color="danger"
                    variant="soft"
                    sx={{ borderRadius: 0 }}
                    endDecorator={
                        <IconButton
                            variant="plain"
                            color="danger"
                            size="sm"
                            onClick={clearAuthError}
                            aria-label="Dismiss error"
                        >
                            <CloseIcon />
                        </IconButton>
                    }
                >
                    {authError}
                </Alert>
            )}

            {claimMessage && (
                <Alert
                    color="success"
                    variant="soft"
                    sx={{ borderRadius: 0 }}
                    endDecorator={
                        <IconButton
                            variant="plain"
                            color="success"
                            size="sm"
                            onClick={clearClaimMessage}
                            aria-label="Dismiss confirmation"
                        >
                            <CloseIcon />
                        </IconButton>
                    }
                >
                    {claimMessage}
                </Alert>
            )}

            <Container disableGutters component="main">
                {children || <Outlet />}
            </Container>

            <Box
                sx={{
                    mt: 'auto',
                }}
            >
                <Footer />
            </Box>
        </Box>
    );
}

export default Layout;
